export default __webpack_public_path__ + "static/media/bg04.f1cecaf7.jpg";